import { GET_ZONAIVA_CENTRO, MODIFY_ZONAIVA_CENTRO, ADD_ZONAIVA_CENTRO, REMOVE_ZONAIVA_CENTRO, } from '../constants/action_types';

const initialState = { zonaIvaCentro: [], isLoading: true };

export default function (state = initialState, action) {

    switch (action.type) {

        case GET_ZONAIVA_CENTRO + "_SUCCESS":

            return {
                zonaIvaCentro: action.payload.data,
                isLoading: false
            };

        case MODIFY_ZONAIVA_CENTRO:

            return {
                zonaIvaCentro: state.zonaIvaCentro.map((caja) => {
                    if (caja.id !== action.payload.id) return caja;
                    else return action.payload;
                }),
                isLoading: false
            };

        case ADD_ZONAIVA_CENTRO:

            const newArr = [...state.zonaIvaCentro, action.payload]

            return {
                zonaIvaCentro: newArr,
                isLoading: false
            };

        case REMOVE_ZONAIVA_CENTRO:

            return {
                zonaIvaCentro: state.zonaIvaCentro.filter(caja => caja.id !== action.payload.id),
                isLoading: false
            };

        default:

            return state;
    };
};